import React from 'react';
import './ButtonPrimary.sass';

import { ReactComponent as Arrow } from '../../Icons/arrow-light-right.svg';
import { ReactComponent as Plus } from '../../Icons/plus-icon.svg';

type ButtonType = JSX.IntrinsicElements['button']['type'];

interface Props {
	submitButtonLabel: string;
	type: 'button' | 'submit' | 'reset';
	disabled?: boolean;
	icon?: string;
	id?: string;
}

function ButtonPrimary({ type, submitButtonLabel, disabled, icon, id }: Props) {
	return (
		<button
			id={id}
			// eslint-disable-next-line react/button-has-type
			type={type}
			className="uikit-button-primary"
			disabled={disabled}
		>
			{submitButtonLabel}
			{icon === 'add' ? <Plus /> : <Arrow />}
		</button>
	);
}

ButtonPrimary.defaultProps = {
	disabled: false,
	icon: '',
	id: '',
};

export default ButtonPrimary;
